export default __webpack_public_path__ + "static/media/AdobeStock_478233385.1828fda2.jpg";